import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Banner from '../../atoms/Banner/Banner';
import ContentBox from '../../molecules/ContentBox';
import HistoryBox from '../../organisms/HistoryBox/HistoryBox';

const bd = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'History',
  text1: 'Introducing Korea’s best security leader training institute, the Korea',
  text2: 'Information Technology Research Institute.',
};

export default function HistoryPage() {
  const classes = useStyles();

  return (
    <Box>
      <Banner bannerData={bd} />
      <ContentBox>
        <Box className={classes.main}>
          <Box className={classes.left}>
            <Box className={classes.textBox}>
              Korea Information Technology Research Institute was established in 1985 for the purpose of software R&D and human resource training as an affiliated organization of
              the Ministry of Trade, Industry and Energy.
            </Box>
          </Box>
          <Box className={classes.right}>
            <HistoryBox />
          </Box>
        </Box>
      </ContentBox>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {},
  main: {
    display: 'flex',

    '@media only screen and (max-width: 1024px)': {
      flexDirection: 'column-reverse',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  left: {
    width: '45%',
    '@media only screen and (max-width:1024px)': {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      marginBottom: '40px',
    },
  },
  textBox: {
    marginTop: '240px',
    maxWidth: '492px',
    width: '100%',
    fontSize: '24px',
    fontWeight: '600',
    padding: '88px 78px',
    boxSizing: 'border-box',
    backgroundColor: '#f4f6f9',
    lineHeight: 1.42,
    '@media only screen and (max-width: 1024px)': {
      marginTop: '80px',
    },
    '@media only screen and (max-width: 768px)': {
      fontSize: '16px',
      padding: '44px 16px',
    },
  },
  right: {
    width: '55%',
    '@media only screen and (max-width:1024px)': {
      width: '100%',
    },
  },
}));
